import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  value: "login",
};

export const activePageSlice = createSlice({
  name: "active page",
  initialState,
  reducers: {
    setActive: (state, action) => {
      state.value = action.payload;
    },
  },
});

export const { setActive } = activePageSlice.actions;

export default activePageSlice.reducer;
